import { Koi } from '@ksyos/koi';

export type ProcessActivityAnamnesis = {
    complaints: string;
    familyHistory: string;
    history: string;
};

export type ProcessActivityAnamnesisData = {
    anamnesis: ProcessActivityAnamnesis;
};

const processActivityAnamnesisSchema = Koi.object({
    complaints: Koi.string().max(10_000),
    familyHistory: Koi.string().max(10_000),
    history: Koi.string().max(10_000),
});

const processActivityAnamnesisDraftSchema = Koi.object({
    complaints: Koi.string().max(10_000).allow(''),
    familyHistory: Koi.string().max(10_000).allow(''),
    history: Koi.string().max(10_000).allow(''),
});

export const processActivityAnamnesisDataSchema = Koi.object({
    anamnesis: processActivityAnamnesisSchema,
});

export const processActivityAnamnesisDraftDataSchema = Koi.object({
    anamnesis: processActivityAnamnesisDraftSchema,
});

export const processActivityAnamnesisInitialData: ProcessActivityAnamnesis = {
    complaints: '',
    familyHistory: '',
    history: '',
};
